import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.public.user-accounts.share', {
        url: '/shareaccounts',
		params: {companies},
        views: {
            '@user': 'sharePublicUserAccounts'
        },
        resolve: {companies},
    })
}

/** @ngInject */
function companies($stateParams,UsersSharedAccountService){
	if(!$stateParams.companies) {
		var coms= UsersSharedAccountService.usersCompanySharedAccounts.getCompaniesToShareWith().$promise;
		return coms;
	}
	return $stateParams.companies;
}



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/share-public-user-account/share-public-user-account.state.js